<div class="container ion-text-center ion-padding">
  <h3 *ngIf="text">
    {{text}}
  </h3>
  <ion-progress-bar *ngIf="progress" class="ion-margin-top ion-margin-bottom" [value]="progress/100" [buffer]="progress/100"></ion-progress-bar>
  <ion-spinner *ngIf="!progress" class="ion-margin-top" name="crescent"></ion-spinner>
</div>